// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"d315164f","64":"577977a6","406":"a3d7c49e","496":"ca96af3e","521":"086ff8c6","631":"60eb44b1"}[chunkId] + ".chunk.js";
};